import { render, staticRenderFns } from "./GuestLayout.vue?vue&type=template&id=35999fbc&scoped=true&"
import script from "./GuestLayout.vue?vue&type=script&lang=js&"
export * from "./GuestLayout.vue?vue&type=script&lang=js&"
import style0 from "./GuestLayout.vue?vue&type=style&index=0&id=35999fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35999fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35999fbc')) {
      api.createRecord('35999fbc', component.options)
    } else {
      api.reload('35999fbc', component.options)
    }
    module.hot.accept("./GuestLayout.vue?vue&type=template&id=35999fbc&scoped=true&", function () {
      api.rerender('35999fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GuestLayout.vue"
export default component.exports